export default __webpack_public_path__ + "static/media/atom.5c4554f3.svg";